<template>
    <layout-general-container>
        <div class="h-screen w-full flex flex-col items-center justify-center">
            <div class="md:border w-full max-w-md flex flex-col items-center p-10 rounded-xl gap-8">
                <span class="text-3xl font-medium">Oops!</span>
                <img src="@/assets/img/not-found.png" class="h-52" alt="">
                <span class="text-center text-sm font-medium text-secondary">This page has been moved permanently.</span>
                <a-button @click="$router.push('/')" type="text"
                    class="w-full text-primary flex flex-row items-center justify-center gap-2">
                    <IconArrowLeft :size="18" />
                    Back To Home
                </a-button>
            </div>
        </div>
    </layout-general-container>
</template>

<script>
import { IconArrowLeft } from "@tabler/icons-vue"

export default {
    name: 'NotFound',
    components: {
        IconArrowLeft
    }
}
</script>